import {LoadingButton} from '@mui/lab';
import {Box, MenuItem, TextField} from '@mui/material';
import dayjs from 'dayjs';
import last from 'lodash/last';
import map from 'lodash/map';
import {useSnackbar} from 'notistack';
import {useState} from 'react';

import API, {getMessagesFromApiError} from '../../api/axios';
import {apiBaseUrl} from '../../api/urls';
import {saveFile} from '../../utils/file';
import {CloseSnackbarAction} from '../common/CloseSnackbarButton';
import SnackbarMessages from '../common/SnackbarMessages';

const FIELD_LABELS = {
  id: 'ID',
  name: 'Name',
  status: 'Status',
  description: 'Description',
};

const FIELDS = map(FIELD_LABELS, (label, value) => ({label, value}));

const AssetHumanTypeExport = () => {
  const {enqueueSnackbar} = useSnackbar();
  const [fields, setFields] = useState<string[]>([]);
  const [isFetching, setIsFetching] = useState(false);

  const fetchData = async () => {
    setIsFetching(true);
    try {
      const resp = await API.get(`${apiBaseUrl}/asset-human-type.csv`, {
        params: {fields},
        responseType: 'blob',
      });
      saveFile(
        resp.data,
        `asset-human-types-${dayjs().format('YYYY-MM-DD')}.csv`
      );
    } catch (error: any) {
      const messages = getMessagesFromApiError(error, "STRA_633bcf87");
      enqueueSnackbar(<SnackbarMessages messages={messages} />, {
        variant: 'error',
        action: CloseSnackbarAction,
      });
    }
    setIsFetching(false);
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <TextField
        label="Fields"
        value={!fields.length ? ['all'] : fields}
        select
        SelectProps={{
          multiple: true,
        }}
        onChange={(event) => {
          const v = event.target.value as unknown as string[];
          const isSelectAll = last(v) === 'all';
          setFields(isSelectAll ? [] : v.filter((i) => i !== 'all'));
        }}
      >
        <MenuItem value="all">All Fields</MenuItem>

        {FIELDS.map((field) => (
          <MenuItem key={field.value} value={field.value}>
            {field.label}
          </MenuItem>
        ))}
      </TextField>
      <Box display="flex" justifyContent="end">
        <LoadingButton
          variant="contained"
          loading={isFetching}
          onClick={() => fetchData()}
        >
          Export to CSV
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default AssetHumanTypeExport;
